export default __webpack_public_path__ + "static/media/DE.03622533.svg";